import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Item } from "./models/Item";

@Injectable()
export class ItemService {

  items: Observable<Item[]>;
  dants: Observable<Item[]>;

  constructor(public afs: AngularFirestore) { 
    this.items = this.afs.collection('escapingPositions').valueChanges();
    this.dants = this.afs.collection('passingPositions').valueChanges();
  }

getItems(){ 
  return this.items;
}

getDants(){
  return this.dants;
}


} 


// WEBPACK FOOTER //
// ./src/app/item.service.ts